import { sql } from 'drizzle-orm';
import {
  pgTable,
  index,
  jsonb,
  timestamp,
  varchar,
  text,
  uuid,
  primaryKey
} from "drizzle-orm/pg-core";
import { claims } from './claims';
import { documentGenerations } from './documents';
import { docusignEnvelopeStatusEnum } from './enums';
import { organizations } from './organizations';
import { users } from './users';

// DocuSign Envelopes - tracking documents sent via DocuSign
export const docusignEnvelopes = pgTable("docusign_envelopes", {
  id: uuid("id").primaryKey().default(sql`gen_random_uuid()`),
  
  // References
  claimId: uuid("claim_id").references(() => claims.id, { onDelete: "cascade" }).notNull(),
  documentGenerationId: uuid("document_generation_id").references(() => documentGenerations.id),
  
  // DocuSign details
  envelopeId: varchar("envelope_id").unique(), // DocuSign envelope ID
  subject: varchar("subject").notNull(),
  message: text("message"),
  
  // Recipients
  recipientEmail: varchar("recipient_email").notNull(),
  recipientName: varchar("recipient_name"),
  signerEmail: varchar("signer_email"), // May be different from recipient
  signerName: varchar("signer_name"),
  
  // Status and tracking
  status: docusignEnvelopeStatusEnum("status").default("draft"),
  statusReason: text("status_reason"), // Reason for declined/voided status
  
  // Important timestamps
  sentAt: timestamp("sent_at"),
  deliveredAt: timestamp("delivered_at"),
  signedAt: timestamp("signed_at"),
  completedAt: timestamp("completed_at"),
  expireAt: timestamp("expire_at"),
  
  // DocuSign URLs
  signingUrl: text("signing_url"), // URL for recipient to sign
  envelopeUrl: text("envelope_url"), // DocuSign console URL
  documentsUrl: text("documents_url"), // URL to download completed docs
  
  // Webhook tracking
  lastWebhookAt: timestamp("last_webhook_at"),
  webhookEvents: jsonb("webhook_events"), // History of webhook events
  
  createdBy: varchar("created_by").references(() => users.id).notNull(),

  orgId: uuid("org_id").references(() => organizations.id, { onDelete: "cascade" }),

  createdAt: timestamp("created_at").defaultNow(),
  updatedAt: timestamp("updated_at").defaultNow(),
}, (table) => [
  index("idx_docusign_envelopes_claim_id").on(table.claimId),
  index("idx_docusign_envelopes_envelope_id").on(table.envelopeId),
  index("idx_docusign_envelopes_status").on(table.status),
  index("idx_docusign_envelopes_recipient_email").on(table.recipientEmail),
  index("idx_docusign_envelopes_sent_at").on(table.sentAt),
]);
